import { Pipe, PipeTransform } from '@angular/core';
import { getCustomerNameWithCompanyForEstInv } from './shared/utils/util-function';

@Pipe({
  name: 'displayCompanyAndUserNameEstInvPipe'
})
export class DisplayCompanyAndUserNameEstInvPipe implements PipeTransform {

  transform(value: any) {
    if (!value) return;
    let response = '';
    response = getCustomerNameWithCompanyForEstInv(value);
    return response;
  }
}
